import { g } from "analytics";
import { apparatusCategories, moduleDisplayIcon } from "apparatus/specs";
import { Icon } from "components/icon";
import { SearchBox } from "components/searchbox";
import { ApparatusList } from "layout/sidebar/sidebar";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Hint } from "view/tooltips";
export const TabbedSidebar = ({ onHidePanel }) => {
    const [currentModule, setCurrentModule] = useState("chemistry");
    const [searchTerm, setSearchTerm] = useState("");
    const { t } = useTranslation();
    const isInSearchMode = searchTerm.length > 0;
    const tabName = isInSearchMode ? t("Search results") : t("apparatus_module." + currentModule);
    return React.createElement("div", { id: "sidebar" },
        React.createElement("div", { id: "apparatus-search" },
            React.createElement(SearchBox, { value: searchTerm, onChange: v => setSearchTerm(v), onBlur: v => g("SearchApparatus", v), placeholder: t("search.apparatus"), tooltip: React.createElement(Hint, { text: t("search.apparatus_hint"), shortcut: { key: "F", ctrl: true } }), throttleMs: 100 })),
        React.createElement("div", { className: "sidebar-tab-header" }, tabName),
        React.createElement(ApparatusList, { key: "sideBar", searchTerm: searchTerm, module: currentModule, onSwitchModule: m => { setCurrentModule(m); setSearchTerm(""); } }),
        React.createElement("div", { className: "sidebar-tabs" },
            React.createElement("span", { className: "line" }),
            React.createElement("ul", { "data-simplebar": true },
                Object.keys(apparatusCategories).map(module => React.createElement(Tab, { active: !isInSearchMode && module == currentModule, hint: t("apparatus_module." + module), icon: moduleDisplayIcon(module), key: module, onClick: () => { setCurrentModule(module); setSearchTerm(""); } })),
                React.createElement("div", { style: { flexGrow: 1 } }),
                React.createElement(Tab, { icon: "arrow-left-to-line", hint: "Hide sidebar", key: "_hide_", active: false, onClick: onHidePanel }))));
};
const Tab = (props) => (React.createElement("li", { className: props.active ? "active" : "", onClick: props.onClick },
    React.createElement(Icon, { name: props.icon, fullWidth: false }),
    props.hint,
    props.badge !== undefined ? React.createElement("div", { className: `badge badge-${props.badge.color} ml-1` }, props.badge.text) : undefined));
